import React, { useState, useCallback, useRef } from 'react';
import './SplitView.css';
import { listenDrag } from '../utils/dragListen';

/**
 * 수직 분할 뷰
 * - children: 좌측(원본) 렌더링
 * - renderClone: 우측(사본) 렌더링 함수 (없으면 children 복제)
 */
const SplitView = ({ children, isSplit, renderClone }) => {
  const [splitRatio, setSplitRatio] = useState(50);
  const containerRef = useRef(null);
  const isDragging = useRef(false);

  const handleDragStart = useCallback((e) => {
    e.preventDefault();
    isDragging.current = true;

    const handleMove = (ev) => {
      if (!isDragging.current || !containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const ratio = ((ev.clientX - rect.left) / rect.width) * 100;
      setSplitRatio(Math.min(80, Math.max(20, ratio)));
    };

    // 분리 창에서도 그 창의 문서로 받는다(utils/dragListen)
    listenDrag(e, handleMove, () => { isDragging.current = false; });
  }, []);

  if (!isSplit) {
    return <>{children}</>;
  }

  return (
    <div className="split-view-container" ref={containerRef}>
      <div className="split-view-pane split-view-primary" style={{ width: `${splitRatio}%` }}>
        {children}
      </div>
      <div className="split-view-divider" onMouseDown={handleDragStart}>
        <div className="split-view-divider-handle" />
      </div>
      <div className="split-view-pane split-view-secondary" style={{ width: `${100 - splitRatio}%` }}>
        {renderClone ? renderClone() : children}
      </div>
    </div>
  );
};

export default SplitView;
